define('TescoMobile_Checkout/js/view/upgrade-step',['Magento_Ui/js/form/form', 'Magento_Checkout/js/model/quote', 'jquery', 'Magento_Checkout/js/model/step-navigator', 'TescoMobile_Checkout/js/action/upgrade/submit-upgrade', 'TescoMobile_Checkout/js/action/upgrade/save-request-sim', 'mage/translate', 'uiRegistry', 'ko', 'underscore', 'mage/url', 'Magento_Checkout/js/model/error-processor', 'Magento_Checkout/js/model/full-screen-loader', '../action/otac-request', '../action/otac-validate', 'mage/validation'], function (Component, quote, $, stepNavigator, saveMpnAction, saveRequestSim, $t, registry, ko, _, urlBuilder, errorProcessor, fullScreenLoader, otacRequestAction, otacValidateAction) {
  'use strict';

  return Component.extend({
    defaults: {
      template: 'TescoMobile_Checkout/upgrade-step',
      visible: false,
      pinSelector: '#otac_code',
      requestSimSelector: '#request_sim input:radio:checked'
    },
    phoneNumber: ko.observable(null),
    pinCode: ko.observable(null),
    currentStep: ko.observable('form'),
    submitDisabled: ko.observable(true),
    codeNotRequested: ko.observable(true),
    requestText: ko.observable($t('Send PIN')),
    deals: ko.observableArray([]),
    needsSimUpdate: ko.observable(false),
    initialize: function () {
      var _quote$getData;
      this._super();
      if (((_quote$getData = quote.getData('extension_attributes')) === null || _quote$getData === void 0 ? void 0 : _quote$getData.tm_quote_type) === 'PAYG_MIGRATION') {
        stepNavigator.registerStep('upgrade-step', 'upgrade-step', $t('Moving to pay monthly'), this.visible, _.bind(this.navigate, this), this.sortOrder);
      }
    },
    validatePin: function () {
      const coUpgradeForm = $('#co-upgrade-form');
      if (coUpgradeForm.validation() && coUpgradeForm.validation('isValid')) {
        $(this.pinSelector).removeAttr('aria-invalid');
        const messageContainer = registry.get('checkout.errors').messageContainer;
        otacValidateAction(messageContainer, $(this.pinSelector).val()).done(function () {
          saveMpnAction(messageContainer, quote.getItems()[0].item_id, this.phoneNumber()).done(function () {
            $('body').trigger('dl-payg-migrate-pin-validate-success');
            if (this.getDealSimTypeOutdated() === true || !this.isSimo()) {
              stepNavigator.next();
            } else {
              this.currentStep('deal');
            }
          }.bind(this));
        }.bind(this));
      }
    },
    getDealSimTypeOutdated: function () {
      var itemId = quote.getItems()[0].item_id,
        simTypes = window.checkoutConfig.tescomobile.specification.sim_type;
      return simTypes[itemId] && simTypes[itemId].indexOf('Standard') > -1 && simTypes[itemId].indexOf('nano') === -1 && simTypes[itemId].indexOf('micro') === -1;
    },
    requestPin: function () {
      const otacNumberField = $('input[name="otac_number"]');
      if (otacNumberField.validation() && otacNumberField.validation('isValid')) {
        otacNumberField.removeAttr('aria-invalid');
        const mpn = $('#otac_number').val();
        const messageContainer = registry.get('checkout.errors').messageContainer;
        if (this.codeNotRequested === false) {
          $('body').trigger('dl-payg-migrate-pin-resend');
        } else {
          $('body').trigger('dl-payg-migrate-pin-send');
        }
        otacRequestAction(messageContainer, mpn).done(function (request) {
          this.phoneNumber(mpn);
          this.requestText($t('Request PIN'));
          this.codeNotRequested(false);
        }.bind(this));
      }
    },
    saveSim: function () {
      var _$;
      saveRequestSim(quote.getQuoteId(), quote.getItems()[0].item_id, !!parseInt((_$ = $(this.requestSimSelector)) === null || _$ === void 0 ? void 0 : _$.val())).done(() => stepNavigator.next());
    },
    initObservable: function () {
      return this._super().observe(['visible']);
    },
    navigate: function (step) {
      step && step.isVisible(true);
    },
    isSimo: function () {
      return quote.getTotals()().items.map(item => {
        var _item$extension_attri;
        return item === null || item === void 0 || (_item$extension_attri = item.extension_attributes) === null || _item$extension_attri === void 0 || (_item$extension_attri = _item$extension_attri.tm_options) === null || _item$extension_attri === void 0 ? void 0 : _item$extension_attri.contract_type;
      }).includes('SIMO');
    }
  });
});

